import { useState } from 'react';

export default function useAccessToken() {
    const getAccessToken = () => {
        return localStorage.getItem('token');
    }
    const [accessToken, setAccessToken] = useState(getAccessToken);

    const saveAccessToken = userToken => {
        console.log(userToken);
        if (!userToken) {
            localStorage.removeItem('token');
        } else {
            localStorage.setItem('token', JSON.stringify(userToken));
        }

        setAccessToken(userToken);
    }

    return {
        accessToken,
        setAccessToken: saveAccessToken,
    }
}